module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1018-108c10cfddaec619c5f9ecbe034c10c1.png";